import { Navigate } from 'react-router-dom';
import Home from "~/features/Home/pages";
import PageNotFound from "../features/NotFound/pages";
import AccountInfo from "../features/Account/pages/AccountInfo";
import AccountPassword from "../features/Account/pages/AccountPassword";
import Customer from "../features/Customer/pages/Customer";
import Supplier from "../features/Supplier/pages/Supplier";
import Attribute from "../features/Attribute/pages/Attribute";
import ProductCategory from "../features/ProductCategory/pages";
import {Product, ProductFormAddEdit} from "../features/Product/pages";
import {PurchaseOrder, PurchaseOrderForm} from "../features/PurchaseOrder";
import {Order} from "../features/Order";
import {Pos} from "../features/Pos";
import {RevenueReport, RevenueByUserReport, RevenueByProductReport} from "../features/Report/pages";
import User from "../features/User/pages/User";
import Permission from "../features/Permission/pages/Permission";
import PosLayout from "../layout/PosLayout/PosLayout";
import IndexedDBDebug from "../features/Debug/IndexedDBDebug";

export const privateRoutes = [
	{ path: "/", component: Home },
	{ path: "*", component: PageNotFound },
	{ path: "/customer", component: Customer },
	{ path: "/supplier", component: Supplier },
	{ path: "/attribute", component: Attribute },
	{ path: "/product-category", component: ProductCategory },
	{ path: "/product", component: Product },
	{ path: "/product/add", component: ProductFormAddEdit },
	{ path: "/product/edit/:id", component: ProductFormAddEdit },
	{ path: "/purchase-order", component: PurchaseOrder },
	{ path: "/purchase-order/add", component: PurchaseOrderForm },
	{ path: "/purchase-order/:id", component: PurchaseOrderForm },
	{ path: "/purchase-order/:id/edit", component: PurchaseOrderForm },
	{ path: "/order", component: Order },
	{ path: "/pos", component: Pos, layout: PosLayout },
	{ path: "/report/revenue", component: RevenueReport },
	{ path: "/report/revenue-by-user", component: RevenueByUserReport },
	{ path: "/report/revenue-by-product", component: RevenueByProductReport },
	{ path: "/user", component: User },
	{ path: "/account/info", component: AccountInfo },
	{ path: "/account/password", component: AccountPassword },
	{ path: "/permission", component: Permission },
	{ path: "/debug/indexeddb", component: IndexedDBDebug },
];

export function PrivateRoutes({children}) {
	// Check if user is logged in
	// If yes, show route
	// Otherwise, redirect to login page
	const isLoggedIn = Boolean(localStorage.getItem('access_token'));

	if (!isLoggedIn) return <Navigate to={process.env.REACT_APP_HOMEPAGE + "/login"} />;

	return children;
}